var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.data.name))]),_c('img',{staticStyle:{"width":"30%"},attrs:{"src":`http://file.haoxinqing.cn/${_vm.data.imgUrl}`,"alt":""}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.instructions)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }